import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { track } from "@/lib/analytics/track";

export function CTASection({
  eyebrow = "Begin Your Project",
  title = "Ready to give your property a professional finish?",
  subtitle = "Request a free estimate and let our team help you plan your next painting project.",
}: {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
}) {
  return (
    <section className="relative py-20 sm:py-28 lg:py-40 bg-[#030303] overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[20rem] bg-amber-500/15 blur-[160px] pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 size-[480px] rounded-full bg-yellow-500/10 blur-3xl pointer-events-none" />
      <div className="max-w-5xl mx-auto px-5 sm:px-6 text-center relative">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-[10px] sm:text-[11px] font-medium tracking-widest uppercase text-amber-200 mb-5 sm:mb-7">
          {eyebrow}
        </div>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-7xl leading-[1.05] text-balance mb-5 sm:mb-6 bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-white/50">
          {title}
        </h2>
        <p className="text-zinc-400 max-w-xl mx-auto text-pretty mb-8 sm:mb-10 text-base sm:text-lg font-light">{subtitle}</p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
          <Link
            to="/contact"
            onClick={() => {
              try {
                if (typeof window !== "undefined" && window.sessionStorage.getItem("mp_from_gallery") === "1") {
                  track.funnel("gallery_to_lead", "cta_click", 2);
                }
              } catch {}
            }}
            className="bg-white text-zinc-950 px-8 py-4 rounded-full text-sm font-semibold hover:bg-amber-300 hover:text-white transition-all duration-500 shadow-[0_0_40px_rgba(255,255,255,0.12)] min-h-[52px] inline-flex items-center justify-center"
          >
            Get a Free Estimate
          </Link>
          <a
            href="tel:6088864598"
            className="inline-flex items-center justify-center gap-2 border border-white/15 text-white px-7 py-4 rounded-full text-sm font-semibold hover:bg-white/5 transition-colors min-h-[52px]"
          >
            <Phone className="size-4" /> (608) 886-4598
          </a>
        </div>
      </div>
    </section>
  );
}